/**
 * Helpers compartidos para pintar avatares circulares de Clientes y Proveedores
 * en las vistas del Critical Path (`CriticalPathHorizontal.js` y
 * `CriticalPathHorizontal1.js`).
 *
 * - Las paletas son DIFERENTES entre clientes y proveedores para distinguirlos
 *   visualmente de un vistazo.
 * - El color asignado a un nombre es estable (mismo nombre → mismo color).
 */

/** Paleta para avatares de PROVEEDOR (tonos sobrios / fríos). */
export const SUPPLIER_AVATAR_COLORS = [
  "#1976d2",
  "#7b1fa2",
  "#388e3c",
  "#f57c00",
  "#0288d1",
  "#5d4037",
  "#c2185b",
  "#00838f",
  "#6a1b9a",
  "#2e7d32",
  "#455a64",
  "#ad1457",
];

/** Paleta para avatares de CLIENTE (tonos más vivos / cálidos). */
export const CLIENT_AVATAR_COLORS = [
  "#00C2A3",
  "#42A5F5",
  "#AB47BC",
  "#26A69A",
  "#FFA726",
  "#EF5350",
  "#66BB6A",
  "#8D6E63",
  "#5C6BC0",
];

/** Iniciales (1-2 chars) de un nombre, en mayúscula. "Pedro del Hiero" → "PD". */
export const getEntityInitial = (name) => {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "?";
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || "?";
  return ((parts[0][0] || "") + (parts[1][0] || "")).toUpperCase();
};

/** Hash determinista (mismo string → mismo número) usado para escoger color. */
const hashString = (str) => {
  let hash = 0;
  const s = String(str || "").trim();
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

/** Color estable para el avatar de un PROVEEDOR. */
export const getSupplierColor = (name) => {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "#9e9e9e";
  return SUPPLIER_AVATAR_COLORS[
    hashString(trimmed) % SUPPLIER_AVATAR_COLORS.length
  ];
};

/** Color estable para el avatar de un CLIENTE. */
export const getClientColor = (name) => {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "#9e9e9e";
  return CLIENT_AVATAR_COLORS[
    hashString(trimmed) % CLIENT_AVATAR_COLORS.length
  ];
};

/** Color estable para avatares de DISEÑADOR (paleta distinta del cliente). */
export const getDesignerColor = (name) => {
  const trimmed = String(name || "").trim();
  if (!trimmed) return "#9e9e9e";
  return SUPPLIER_AVATAR_COLORS[
    hashString(`designer:${trimmed}`) % SUPPLIER_AVATAR_COLORS.length
  ];
};

/** Colores fijos para Development (Own vs Client). */
export const getDevelopmentColor = (value) => {
  const v = String(value || "").trim().toLowerCase();
  if (v === "own development") return "#00897b";
  if (v === "client development") return "#ef6c00";
  return "#9e9e9e";
};
